/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskMetric } from './RiskMetric';
import { RiskMetricFromJSON, RiskMetricFromJSONTyped, RiskMetricToJSON } from './RiskMetric';

/**
 *
 * @export
 * @interface PatchedRiskMetricResult
 */
export interface PatchedRiskMetricResult {
  /**
   *
   * @type {number}
   * @memberof PatchedRiskMetricResult
   */
  readonly id?: number;
  /**
   *
   * @type {RiskMetric}
   * @memberof PatchedRiskMetricResult
   */
  readonly metric?: RiskMetric;
  /**
   *
   * @type {number}
   * @memberof PatchedRiskMetricResult
   */
  value?: number;
  /**
   *
   * @type {number}
   * @memberof PatchedRiskMetricResult
   */
  confidenceLow?: number | null;
  /**
   *
   * @type {number}
   * @memberof PatchedRiskMetricResult
   */
  confidenceHigh?: number | null;
  /**
   *
   * @type {number}
   * @memberof PatchedRiskMetricResult
   */
  drift?: number | null;
  /**
   *
   * @type {string}
   * @memberof PatchedRiskMetricResult
   */
  readonly assessmentId?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedRiskMetricResult
   */
  comment?: string;
  /**
   *
   * @type {boolean}
   * @memberof PatchedRiskMetricResult
   */
  isApplicable?: boolean;
}

/**
 * Check if a given object implements the PatchedRiskMetricResult interface.
 */
export function instanceOfPatchedRiskMetricResult(value: object): value is PatchedRiskMetricResult {
  return true;
}

export function PatchedRiskMetricResultFromJSON(json: any): PatchedRiskMetricResult {
  return PatchedRiskMetricResultFromJSONTyped(json, false);
}

export function PatchedRiskMetricResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedRiskMetricResult {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    metric: json['metric'] == null ? undefined : RiskMetricFromJSON(json['metric']),
    value: json['value'] == null ? undefined : json['value'],
    confidenceLow: json['confidence_low'] == null ? undefined : json['confidence_low'],
    confidenceHigh: json['confidence_high'] == null ? undefined : json['confidence_high'],
    drift: json['drift'] == null ? undefined : json['drift'],
    assessmentId: json['assessment_id'] == null ? undefined : json['assessment_id'],
    comment: json['comment'] == null ? undefined : json['comment'],
    isApplicable: json['is_applicable'] == null ? undefined : json['is_applicable'],
  };
}

export function PatchedRiskMetricResultToJSON(
  value?: Omit<PatchedRiskMetricResult, 'id' | 'metric' | 'assessmentId'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    value: value['value'],
    confidence_low: value['confidenceLow'],
    confidence_high: value['confidenceHigh'],
    drift: value['drift'],
    comment: value['comment'],
    is_applicable: value['isApplicable'],
  };
}
